import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, SectionLabel } from "@/components/Reveal";

const STEPS = [
  { n: "I", t: "Apply", d: "Tell us about your business, volume and the jurisdictions you sell into." },
  { n: "II", t: "Underwrite & place", d: "We review the file and place you with the right bank — US or across the FinBPM network." },
  { n: "III", t: "Go live", d: "Hardware ships, gateway keys issue, and cross-border lanes open." },
];

export function Process() {
  return (
    <section className="relative border-t border-white/10" data-testid="process-section">
      <div className="mx-auto max-w-[1400px] px-5 py-28 sm:px-10 sm:py-36">
        <Reveal><SectionLabel index="04">How boarding works</SectionLabel></Reveal>
        <div className="mt-14 grid gap-px bg-white/10 md:grid-cols-3">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.1} className="bg-[#080B11] p-8 sm:p-10" data-testid={`process-step-${i + 1}`}>
              <span className="font-display text-6xl font-light text-[var(--gold)]">{s.n}</span>
              <h3 className="mt-10 font-display text-2xl font-medium">{s.t}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-300">{s.d}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export function ClosingCTA() {
  return (
    <section className="relative overflow-hidden" data-testid="closing-cta">
      <img src="/img/vault.jpg" alt="" className="absolute inset-0 h-full w-full object-cover opacity-30 grayscale" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_70%_50%,rgba(8,11,17,0.3),#080B11_75%)]" />
      <div className="relative mx-auto max-w-[1400px] px-5 py-32 sm:px-10 sm:py-48">
        <Reveal>
          <p className="eyebrow">Declined elsewhere?</p>
          <h2 className="mt-6 max-w-4xl font-display text-5xl font-semibold leading-[0.95] tracking-[-0.03em] sm:text-7xl lg:text-8xl">
            Bring us the file <span className="outline-text">nobody else</span> would sign.
          </h2>
          <div className="mt-12 flex flex-wrap gap-3">
            <Link to="/apply" className="btn-primary" data-testid="cta-apply-button">Start your application <ArrowRight className="h-4 w-4" /></Link>
            <Link to="/store" className="btn-ghost" data-testid="cta-store-button">Shop hardware</Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
